export const ACTIVATE_PROFILE = 'page/PROFILE [activate]';
export const LEAVE_PROFILE = 'page/PROFILE [leaving]';

export const PROFILE_DATA = 'page/PROFILE_DATA [done]';
export const PROFILE_DATA_LOADING = 'page/PROFILE_DATA [loading]';
export const PROFILE_CONFIRM_REROUTING = 'page/PROFILE_CONFIRM_REROUTING';
export const OPEN_PROMPT = 'page/OPEN_PROMPT';
export const CANCEL_PROMPT = 'page/CANCEL_PROMPT';
export const TOGGLE_ADD_DEBIT_CARD_FORM = 'page/TOGGLE_ADD_DEBIT_CARD_FORM';
